export const DisputeType = {
  SERVICE_NOT_DELIVERED: 'SERVICE_NOT_DELIVERED',
  QUALITY_ISSUE: 'QUALITY_ISSUE',
  PAYMENT_DISPUTE: 'PAYMENT_DISPUTE',
  CANCELLATION_DISPUTE: 'CANCELLATION_DISPUTE',
  OTHER: 'OTHER',
} as const;
export type DisputeType = (typeof DisputeType)[keyof typeof DisputeType];

export const DisputeStatus = {
  OPEN: 'OPEN',
  UNDER_REVIEW: 'UNDER_REVIEW',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
} as const;
export type DisputeStatus = (typeof DisputeStatus)[keyof typeof DisputeStatus];
